import { useState } from 'react'

import { faCheck, faCopy, faSlidersSimple } from '@fortawesome/pro-light-svg-icons'

import { trackClickForSegmentAnalytics } from '@infura/packages.common/segmentAnalytics'
import { ActionLink } from '@infura/packages.ui/ActionLink'

import { useSetSelectedApiKey } from 'components/keySelection/Context'

type ActionColumnProps = {
  id: string
  keyName: string
}

const baseTrackingProps = {
  location: 'Dashboard API Key Table'
}

export const ActionColumn = ({ id, keyName }: ActionColumnProps) => {
  const [copiedKey, setCopiedKey] = useState(false)
  const setSelectedKey = useSetSelectedApiKey()

  const copyKey = () => {
    setCopiedKey(true)
    setTimeout(() => {
      setCopiedKey(false)
    }, 3000)
  }

  return (
    <div className='align-center flex w-[220px] gap-4'>
      <ActionLink
        data-testid={`table-configure-link-${keyName.replace(/\s/g, '-')}`}
        href='/key/settings'
        icon={faSlidersSimple}
        iconPosition='left'
        onClick={() => {
          setSelectedKey(id)
          trackClickForSegmentAnalytics({
            ...baseTrackingProps,
            clickText: 'Configure Key',
            type: 'Text'
          })
        }}
      >
        Configure
      </ActionLink>
      <ActionLink
        icon={copiedKey ? faCheck : faCopy}
        iconPosition='left'
        onClick={() => {
          navigator.clipboard.writeText(id)
          copyKey()
          trackClickForSegmentAnalytics({
            ...baseTrackingProps,
            clickText: 'Copy Key',
            type: 'Button'
          })
        }}
      >
        Copy Key
      </ActionLink>
    </div>
  )
}
